var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.path,"stroke":"currentColor","stroke-linecap":"round","stroke-width":_vm.strokeWidth}})])
}
var staticRenderFns = []

export { render, staticRenderFns }